import { TelegramIcon } from "./TelegramButton";

// Floating launcher in the spot the old Live Chat widget occupied (bottom-right, all pages).
export const ChatLauncher = () => (
  <div className="fixed bottom-6 right-5 sm:right-7 z-40" data-testid="chat-launcher">
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event("open-enquiry-chat"))}
      aria-label="Chat With Us"
      title="Chat With Us"
      data-testid="chat-launcher-btn"
      className="inline-flex items-center gap-2.5 bg-[#229ED9] hover:bg-[#1B8CC2] text-white font-semibold rounded-full text-sm pl-4 pr-5 py-3.5 shadow-xl shadow-black/40 transition-all duration-300 hover:-translate-y-0.5"
    >
      <TelegramIcon size={20} /> Chat With Us
    </button>
  </div>
);
